var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"tf_phone",staticClass:"w_full",class:_vm.classObject,attrs:{"type":"text","placeholder":"휴대폰번호"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"paste":_vm.handlePaste,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.action_Done()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }